module.exports = __webpack_public_path__ + "img/CTIM_w_trans.496b8a58.png";